// extracted by mini-css-extract-plugin
export default {"item":"cardSlider_item__4euLF","cardSlider_container":"cardSlider_cardSlider_container__tpz7Y"};